var _g, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.066,
    height: 21.92,
    viewBox: "0 0 22.066 21.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M133.379-572.96v-7.14h7.434",
    transform: "translate(-133.379 580.099)",
    fill: "none",
    stroke: "#2c2c2c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M140.812-572.96v-7.14h-7.434",
    transform: "translate(-120.746 580.099)",
    fill: "none",
    stroke: "#2c2c2c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M0,7.14V0H7.434",
    transform: "translate(0.147 19.92) rotate(-90)",
    fill: "none",
    stroke: "#2c2c2c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M0,0V7.14H7.434",
    transform: "translate(12.78 19.92) rotate(-90)",
    fill: "none",
    stroke: "#2c2c2c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    y2: 7.978,
    transform: "translate(11.093 6.674)",
    fill: "none",
    stroke: "#2c2c2c",
    strokeLinecap: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x2: 7.978,
    transform: "translate(7.104 10.663)",
    fill: "none",
    stroke: "#2c2c2c",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.a147b7895369c509ec30af8c272570be.svg";
export { ForwardRef as ReactComponent };